import { Injectable } from '@angular/core';
import { Event } from '../../../../../shared/models/event.model';
import * as moment from 'moment';
import { Venue } from '../../../../../shared/models/venue.model';
import { Format } from '../../../../../shared/enums/format.enum';
import { SiteHoursModel } from '../models/site-hours.model';
import { EventMasterAttributeEnum } from '../../../../../shared/enums/eventmasterattributes.enum';
import { EventMasterAttribute } from '../../../../../shared/models/eventmasterattribute.model';
import { VenueTypeEnum } from '../../../../../shared/enums/venue-type.enum';
import { ScheduleWarning } from '../../../../../shared/models/schedule-warning.model';

@Injectable({
  providedIn: 'root'
})
export class EntityMapperService {

  static isEventMasterAttributeExists(attributes: EventMasterAttribute[],  att: EventMasterAttributeEnum): boolean {
    if (attributes) {
      return  attributes.find((a) => a.eventMasterAttributeId === att) != null;
    }
    return  false;
  }

  constructor() { }


  mapEventFromApi(data: any): Event {
    return {
      siteId: data.siteId || null,
      eventId: data.eventId || null,
      eventMasterId: data.eventMasterId || null,
      venueId: data.venueId,
      dateTimeOfEvent:  data.dateTimeOfEvent ? moment(data.dateTimeOfEvent).toDate() : null,
      businessDate: data.businessDate ? moment(data.businessDate).toDate() : null,
      eventMasterName : data.eventMasterName || null,
      lengthInMinutes: data.lengthInMinutes,
      venueName: data.venueName,
      eventTypeId: data.eventTypeId,
      grossLengthInMinutes: data.grossLengthInMinutes,



      isActive: data.isActive || false ,
      isPrivate: data.isPrivate || false ,
      isCanceled: data.isCanceled || false ,




      intermissionLengthInMinutes: data.intermissionLengthInMinutes || 0,
      eventMasterClassAdvertisingLengthInMinutes: data.emcadvertisingLengthInMinutes || 0,
      eventMasterClassCleaningTimeInMinutes: data.emccleaningTimeInMinutes || 0,
      trailerLengthInMinutes: data.trailerLengthInMinutes || 0,
      venueCleaningTimeInMinutes: data.venueCleaningTimeInMinutes || 0,
      specialEventId: data.specialEventId,
      eventMasterIdentifier: data.eventMasterId + '-' + data.specialEventId,
      warnings: (data.warnings || []).map(warning => this.mapScheduleWarning(warning)),
      soldTickets: data.soldTickets || 0,
      seatsUsed: data.seatsUsed || 0,
      orderedBy: data.orderedBy || null,
      createdBy: data.createdBy || null
    };
  }

  mapScheduleWarning(data: any): ScheduleWarning | null {
    return {
      scheduleWarningType : data.scheduleWarningType,
      data : new Map(Object.entries(data.data))
    };
  }


  mapVenueFromApi(data: any): Venue {
    return {
      venueId: data.venueId || null,
      shortName: data.shortName || null,
      name: data.name || null,
      venueTypeName: data.venueTypeName || null,
      formatIds: data.formatIds || null,
      formatNames: data.formatNames || '',
      cleaningTimeInMinutes: data.cleaningTimeInMinutes || 0,
      defaultVenueSeatPlanGeneralCapacity: data.defaultVenueSeatPlanGeneralCapacity || 0,
      defaultVenueSeatPlanReservedCapacity: data.defaultVenueSeatPlanReservedCapacity || 0,
      venueTypeId: data.venueTypeId || null,

      is2D: data.formatIds && data.formatIds.split(',').includes(Format.TWOD.toString()),

      attributes: data.attributes || null,

      is3D: EntityMapperService.isEventMasterAttributeExists(data.attributes, EventMasterAttributeEnum.ThreeDimension),
      isImax:  (data.venueTypeId &&  data.venueTypeId === VenueTypeEnum.IMAX) || false,
      is4DX:  (data.venueTypeId &&  data.venueTypeId === VenueTypeEnum.FourDX) || false,
      isVIP:  (data.venueTypeId &&  data.venueTypeId === VenueTypeEnum.VIP) || false,
      isScreenX : (data.venueTypeId &&  data.venueTypeId === VenueTypeEnum.ScreenX) || false

    };
  }






  mapSiteHoursFromApi(data: any): SiteHoursModel {
    return {
      d: data.d || null,
      openInMinutes: data.open || null,
      closeInMinutes: data.close || null
    };
  }



  private boolOrNull(data: any) {
    return typeof data === 'undefined' ? null :  data;
  }



}
